import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const authentication = {
    authenticate,
    forgotPassword,
}

async function authenticate({
    username,
    password,
    two_factor_method,
    provider = "EMAIL",
    organisation_id,
    sso_provider,//{token, state}
}, accessToken) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/authenticate',
            logOutIfSessionInvalid: false,
            withoutApikey: true,
            body: {
                username,
                password,
                two_factor_method,
                provider,
                organisation_id,
                sso_provider,
            },
            accessToken
        });

        console.log("AAAA authenticate response: ", response)
        if (response.code == 'OK') {
            if (response.data.two_factor_required && response.data.two_factor_required == true) {
                httpBackOfficeUtil.startSessionForVerify(response.data)
            }
            else {
                httpBackOfficeUtil.clearSessionForVerify();
                httpBackOfficeUtil.startSession(response.data)
            }
            return createResult(ErrorCodes.OK, response.data)
        } else {
            if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION")) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else if (response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.EMAILNOTVERIFIEDEXCEPTION") {
                return createResult(ErrorCodes.EMAIL_NOT_VERIFIED, response.error);
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA authenticate exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function forgotPassword({email}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/forgot_password',
            logOutIfSessionInvalid: false,
            withoutApikey: true, 
            body: {
                email
            },
        });

        console.log("AAAA forgotPassword response: ", response)
        if (response.code == 'OK') {
            return createResult(ErrorCodes.OK, response.data)
        } else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA authenticate exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

